import React from 'react'
import './WelcomeMessage.scss'

const WelcomeMessage = () => {
  return (
    <div className="WelcomeMessage">
      <h2>Welcome to Firechat!</h2>
      <p>You can now start chatting with people around the globe. Start by introducing yourself!</p>
    </div>
  )
}

export default WelcomeMessage